// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelTasks extends React.Component<Props> {
  get headlineData() {
    return [
      {
        id: "outstanding-tasks",
        label: this.props.t("TOTAL_OUTSTANDING_TASKS"),
        details: this.props.t("TASKS_OUTSTANDING_DESCRIPTION"),
      },
      {
        id: "rtw-interviews",
        label: this.props.t("TUTORIAL_RTW_INTRVIEWS"),
        details: this.props.t("TASKS_RTW_DESCRIPTION"),
      },
      {
        id: "absence-monitoring",
        label: this.props.t("ABSENCE_MONITORING_REVIEWS"),
        details: this.props.t("TASKS_ABSENCE_MONITORING_REVIEWS_DESCRIPTION"),
      },
      {
        id: "wellbeing-referrals",
        label: this.props.t("WELLBEING_REFERRALS"),
        details: this.props.t("TASKS_WELLBEING_DESCRIPTION"),
      },
      {
        id: "overdue-tasks",
        label: this.props.t("OVERDUE_TASKS"),
        details: this.props.t("TASKS_OVERDUE_DESCRIPTION"),
      },
    ];
  }

  get filtersAndSearchData() {
    return [
      {
        id: "search-bar",
        label: this.props.t("SEARCH_BAR"),
        details: this.props.t("TASKS_SEARCH_BAR_DESCRIPTION"),
      },
      {
        id: "filters",
        label: this.props.t("FILTER_QUEUE"),
        details: this.props.t("TASKS_FILTER_QUEUE_DESCRIPTION"),
      },
      {
        id: "pagination",
        label: this.props.t("PAGINATION"),
        details: this.props.t("TASKS_PAGINATION_DESCRIPTION"),
      },
    ];
  }

  get taskQueueData() {
    return [
      {
        id: "id",
        label: this.props.t("ID"),
        details: this.props.t("TASKS_ID_DESCRIPTION"),
      },
      {
        id: "type",
        label: this.props.t("TYPE"),
        details: this.props.t("TASKS_TYPE_DESCRIPTION"),
      },
      {
        id: "employee-name",
        label: this.props.t("EMPLOYEE_NAME"),
        details: this.props.t("TASKS_EMPLOYEE_NAME_DESCRIPTION"),
      },
      {
        id: "absence-id",
        label: this.props.t("ABSENCE_ID"),
        details: this.props.t("TASKS_ABSENCE_ID_DESCRIPTION"),
      },
      {
        id: "start-date",
        label: this.props.t("ABSENCE_START_DATE"),
        details: this.props.t("TASKS_ABSENCE_START_DATE_DESCRIPTION"),
      },
      {
        id: "due-date",
        label: this.props.t("DUE_DATE"),
        details: this.props.t("TASKS_DUE_DATE_DESCRIPTION"),
      },
      {
        id: "status",
        label: this.props.t("STATUS"),
        details: this.props.t("TASKS_STATUS_DESCRIPTION"),
      },
      {
        id: "action",
        label: this.props.t("ACTION"),
        details: this.props.t("TASKS_ACTION_DESCRIPTION"),
      },
    ];
  }

  get taskFormData() {
    return [
      {
        id: "employee-details",
        label: this.props.t("EMPLOYEE_DETAILS"),
        details: this.props.t("TASKS_EMPLOYEE_DETAILS_DESCRIPTION"),
      },
      {
        id: "absence-details",
        label: this.props.t("ABSENCE_DETAILS"),
        details: this.props.t("TASKS_ABSENCE_DETAILS_DESCRIPTION"),
      },
      {
        id: "questions",
        label: this.props.t("QUESTIONS"),
        details: this.props.t("TASKS_QUESTIONS_DESCRIPTION"),
      },
      {
        id: "print-form",
        label: this.props.t("PRINT_FORM"),
        details: this.props.t("TASKS_PRINT_FORM_DESCRIPTION"),
      },
      {
        id: "save-draft",
        label: this.props.t("SAVE_DRAFT"),
        details: this.props.t("TASKS_SAVE_DRAFT_DESCRIPTION"),
      },
      {
        id: "submit",
        label: this.props.t("SUBMIT"),
        details: this.props.t("TASKS_SUBMIT_DESCRIPTION"),
      },
      {
        id: "late-submission",
        label: this.props.t("LATE_SUBMISSION"),
        details: this.props.t("TASKS_LATE_SUBMISSION_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("TASKS_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.TASKS_INSTRUCTIONS}
            title={this.props.t("TASKS_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("HEADLINE_STATISTICS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.headlineData} />
        <h6 className="font-weight-bold">{this.props.t("FILTERS_AND_SEARCH")}</h6>
        <SimpleGrid
          className="theme-help"
          columns={this.columns}
          rows={this.filtersAndSearchData}
        />
        <h6 className="font-weight-bold">{this.props.t("TASK_QUEUE")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.taskQueueData} />
        <h6 className="font-weight-bold">{this.props.t("TASK_FORM")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.taskFormData} />
      </div>
    );
  }
}

export default localize()(HelpPanelTasks);
